"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterval = useInterval;
exports.useActiveUserInterval = useActiveUserInterval;
const react_1 = require("react");
const use_user_activity_1 = require("./use_user_activity");
/**
 * Hook to trigger a callback periodically, cleaning up the timer
 * if the hook gets unmounted
 *
 * @param callback function to trigger each interval
 * @param interval interval in ms
 */
function useInterval(callback, interval) {
    const savedCallback = (0, react_1.useRef)();
    savedCallback.current = callback;
    // Set up the interval.
    (0, react_1.useEffect)(() => {
        function tick() {
            if (savedCallback.current !== undefined) {
                savedCallback.current();
            }
        }
        if (interval > 0) {
            const id = setInterval(tick, interval);
            return () => clearInterval(id);
        }
        return;
    }, [interval]);
}
/**
 * Use interval that changes its timing based on user's current active state, allows
 * for the interval to change as the user becomes idle
 * Immediately triggers interval if user goes from idle to active
 *
 * @param callback to trigger
 * @param options configuration for the interval
 */
function useActiveUserInterval(callback, { activeInterval, idleInterval }) {
    const isUserActive = (0, use_user_activity_1.useIsUserActive)();
    useInterval(callback, isUserActive ? activeInterval : idleInterval);
}
//# sourceMappingURL=use_interval.js.map